import { QuestionMarkIcon } from "@components/Icons/QuestionMark";
import { FC, useEffect } from "react";
import { FieldErrors, FieldValues, UseFormGetValues, UseFormSetValue } from "react-hook-form";

type Props = {
  label?: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  requiredMessage?: string;
  errors?: FieldErrors<FieldValues>;
  className?: string;
  autoComplete?: string;
  disabled?: true;
  tooltip?: string;
  tooltipPosition?: "left" | "right";
  onClick?: () => void;
  getValues: UseFormGetValues<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  defaultChecked?: boolean;
};

export const Toggle: FC<Props> = ({
  label,
  name,
  required,
  requiredMessage,
  errors,
  className,
  tooltip,
  tooltipPosition = "right",
  getValues,
  setValue,
  onClick,
  defaultChecked,
  ...props
}) => {
  const errorMessage = (errors[name]?.message || requiredMessage) as string;

  useEffect(() => {
    if (defaultChecked !== undefined && getValues(name) === undefined) {
      setValue(name, defaultChecked);
    }
  }, [defaultChecked, getValues, name, setValue]);

  return (
    <div className="form-control mt-4 flex w-full flex-row justify-between">
      <span className="flex">
        <label className="label cursor-pointer" htmlFor={name}>
          <div className="label-text mr-3 text-sm">
            <span className="label-text">
              {label} {required ? <span className="text-warning">*</span> : <></>}
            </span>
          </div>
        </label>
        {tooltip && (
          <span className={`tooltip-tight-${tooltipPosition} tooltip tooltip-top mt-1 mr-4 inline`} data-tip={tooltip}>
            <QuestionMarkIcon className="inline h-5 w-5 text-neutral opacity-60" strokeWidth={0.2} />
          </span>
        )}
      </span>
      <div className="flex items-center">
        <input
          id={name}
          type="checkbox"
          className={`toggle-primary toggle ${className ?? ""}`}
          checked={getValues(name)}
          onClick={(e) => {
            const value = (e.target as HTMLInputElement).checked;
            setValue(name, value);
            onClick && onClick();
          }}
          {...props}
        />
        {errors[name] && <span className="pl-1 pt-2 text-xs text-warning">{errorMessage}</span>}
      </div>
    </div>
  );
};
